/* unplugin-vue-components disabled */import { render } from "./DashboardBarChart.vue?vue&type=template&id=9f949a1a&ts=true"
import script from "./DashboardBarChart.vue?vue&type=script&lang=ts"
export * from "./DashboardBarChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__